import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { auth, supabase } from '@/lib/supabase';
import { Button, Card, Input } from '@/components/ui';

export function PasswordRecoveryPage({ reset = false }: { reset?: boolean }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [ready, setReady] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    if (!reset) return;
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setReady(!!session);
    });
    return () => subscription.unsubscribe();
  }, [reset]);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    setError('');
    if (reset && password !== confirmPassword) {
      setError('Le password non corrispondono');
      return;
    }
    setBusy(true);
    try {
      const result = reset ? await auth.updatePassword(password) : await auth.resetPassword(email.trim());
      if (result.error) {
        setError(reset ? 'Link scaduto o password non accettata. Richiedi un nuovo link e riprova.' : 'Impossibile inviare il link. Riprova tra qualche minuto.');
      } else {
        setSuccess(true);
      }
    } catch {
      setError('Connessione non disponibile. Riprova.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-teal-50 to-blue-50 flex items-center justify-center p-4">
      <Card padding="lg" className="w-full max-w-md">
        <h1 className="text-xl font-semibold text-gray-900 mb-4">{reset ? 'Scegli una nuova password' : 'Recupera la password'}</h1>
        {success ? (
          <p role="status" className="text-gray-600">{reset ? 'Password aggiornata. Puoi accedere con la nuova password.' : 'Se esiste un account con questa email, riceverai un link per scegliere una nuova password.'}</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            {error && <p role="alert" className="text-sm text-red-600">{error}</p>}
            {reset ? (
              <>
                {!ready && <p className="text-sm text-gray-600">Apri il link ricevuto via email. Se è scaduto, <Link to="/forgot-password" className="text-teal-600 underline">richiedi un nuovo link</Link>.</p>}
                <Input label="Nuova password" type="password" autoComplete="new-password" minLength={8} required value={password} onChange={e => setPassword(e.target.value)} />
                <Input label="Conferma password" type="password" autoComplete="new-password" minLength={8} required value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
              </>
            ) : <Input label="Email" type="email" autoComplete="email" required value={email} onChange={e => setEmail(e.target.value)} />}
            <Button type="submit" className="w-full" isLoading={busy} disabled={reset && !ready}>{reset ? 'Aggiorna password' : 'Invia link di recupero'}</Button>
          </form>
        )}
        <Link to="/login" className="inline-block mt-6 text-sm text-teal-600">Torna al login</Link>
      </Card>
    </div>
  );
}
